// DS1.7.21
import React from 'react';
import c from 'classnames';
import CoreSymbol from '../CoreSymbol';
import { IconSize } from '../../Icons/IconWrap';
import s from './CoreUpgrade.scss';

interface Props {
  className?: string;
}

const CoreUpgrade: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
}) => {
  return (
    <div className={c(s['root'], className)}>
      <CoreSymbol size={IconSize.SMALL} />
      {children}
    </div>
  );
};
CoreUpgrade.displayName = 'CoreUpgrade';

export default CoreUpgrade;
